import { AnalyticsLibraryService } from './analytics-library.service';
//import { PrecalculatedConfiguration } from './shared/precalculated-configuration.interface';
import { DataEntry } from './shared/data-entry.interface';
import { Injectable, ViewChild } from '@angular/core';
//import { FindValueOperator } from 'rxjs/internal/operators/find';
import { CommonService } from './page/common.service';
import { WebcallsService } from 'src/app/webcalls.service';
import { TranslateService } from '@ngx-translate/core';
import { listenerCount } from 'process';

export interface addonItem {
   itemID?: number;
   quantity?: number;
   code?: string,
   systemID?: number;
   mnemonic?: number;
  }

@Injectable({ providedIn: "root" })
export class DataproviderService {
  private baseURL: string = "http://localhost/btcapitolati/";
  private localization: {};
  private housingTypes: any[];
  private HousingTypeID: number = 0;
  private Finishings: any[];
  private finishing: DataEntry;
  private shape: DataEntry;
  private time: DataEntry;
  private FinishingID: number = 0; /* 1 - axolute / 2 - Matix / 3 - LivingLight / 4 - LivingNow */
  private serieID: number = 0;
  private switchID: number = 1;
  private digitalCommands: boolean = false;
  private TechnologyID: number = 0; /* 1 - Tradizionale / 2 - Smart / 3 - MyHome */
  private whatToDo: DataEntry;
  private packagesType: number;
  private cachedRooms: any[];
  //private rooms: any[];
  private cachedSystems: any[];
  private systems: any[];
  private technologies: [];
  private totalPoints: {};
  private cover: {};
  private internalUnit: any[];// {[key: string]: any};
  private smartThermo: any[];
  private smartThermoAddon: any[];
  private smartCamera: any[];
  private smartCameraAddon: any[];
  private homeAutomationSystems = ["NUV"];
  public languageCode: string = "it";
  public gtmAccountID: string = "";
  private havingBTicino: DataEntry;
  public housingTypeCustomise = true;
  private packageItems = [];
  private selectedPlate = undefined;
  private selectedSwitch = undefined;
  private termoSystemZona: string = "one";
  private termoSystemType: string = "free";
  private termoHeatingSystem: string = "radiators";
  private UUID: string = "";
  //b2c form params
  public userID: number;
  public summaryFormData: { name: string, surname: string, email: string, privacy: boolean, marketing: boolean } = { name: '', surname: '', email: '', privacy: false, marketing: false};
  public sendQuotationFormData: { name: string, surname: string, email: string, telephone: string, province: string, city: string,postalcode: string, address: string , message: string, privacy: boolean, share: boolean } = { name: '', surname: '', email: '', telephone: '', province: '', city: '',postalcode: '', address: '', message: '', privacy: false, share: false};
  private totalAmount: {rangeMin: number, rangeMax: number , amount: number };

  private cachedCoverConfiguratorData: any;

  private dataEntryTimes: DataEntry[];
  private dataEntryShapes: DataEntry[];
  private dataEntrySwitch: DataEntry[];


  private listInstallersWS: any[];
  private selectedInstaller: DataEntry;
  private provinceOfSelectedInstaller: string;
  private selectedInstallerFullData: {id: number, name: string, province: string, city: string, address: string, email: string, idsalesforce: string}


  constructor(
    private cs: CommonService,
    private ws: WebcallsService,
    private als: AnalyticsLibraryService,
    private ts: TranslateService
  ) {}


  public resetDataProvider(){
    this.cachedRooms=undefined;
    this.systems=undefined;
    this.whatToDo = undefined;
    this.internalUnit = this.getDefaultInternalUnit();
    this.smartCameraAddon = this.getDefaultSmartCameraAddon();
    this.smartThermoAddon = this.getDefaultSmartThermoAddon();
    this.dataEntryTimes = this.getDefaultTimes();
    this.time=undefined;
    this.finishing=undefined;
    this.FinishingID=-1;
    this.selectedPlate = undefined;
    this.selectedSwitch = undefined;
    this.dataEntryShapes=this.getDefaultShapes();
    this.dataEntrySwitch=this.getDefaultSwitches();
    this.dataEntryTimes=this.getDefaultTimes();
  }


  getDefaultWhatToDo(){
    let defaultWhatToDo: DataEntry[] = [
      {
        ID: 1,
        name: "b2c.IDS_NEW_IMPLANT",
        name_ref: "new",
        description: "b2c.IDS_NEW_IMPLANT_DESC",
        tooltip: "b2c.IDS_NEW_IMPLANT_TIP",
        imageClassFromFrontEnd: "rem-3-375 home",
        checked: false,
        lateralPanelId: "new-lateral"
       },
       {
         ID: 2,
       name: "b2c.IDS_MOD_IMPLANT",
       name_ref: "edit",
       description: "b2c.IDS_MOD_IMPLANT_DESC",
       tooltip: "b2c.IDS_MOD_IMPLANT_TIP",
       imageClassFromFrontEnd: "rem-3-375 camera",
       checked: false
     },
     {
       ID: 3,
       name: "b2c.IDS_UPD_IMPLANT",
       name_ref: "update",
       description: "b2c.IDS_UPD_IMPLANT_DESC",
       tooltip: "b2c.IDS_UPD_IMPLANT_TIP",
       imageClassFromFrontEnd: "rem-3-375 ic-metri",
       checked: false,
       lateralPanelId: "smart-lateral"
     }
   ];
    return defaultWhatToDo;
  }

  getDefaultSwitches(){
    let defaultSwitches: DataEntry[] = [
      { ID: 1, name:"b2c.IDS_WHITE", description: "", tooltip: "", image: "../../assets/img/btns/switch-1.png", checked: false },
      { ID: 2, name:"b2c.IDS_SAND", description: "", tooltip: "", image: "../../assets/img/btns/switch-2.png", checked: false },
      { ID: 3, name:"b2c.IDS_BLACK", description: "", tooltip: "", image: "../../assets/img/btns/switch-3.png", checked: false }
    ];
    return defaultSwitches;
  }

  getDefaultShapes(){
    let defaultShapes: DataEntry[] = [
      { ID: 1, name:"b2c.IDS_SQUARE", name_ref: "square", description: "b2c.IDS_SQUARE_DESCR", tooltip: null, imageClassFromFrontEnd: "rem-3-375 ic-square", checked: false },
      { ID: 2, name:"b2c.IDS_AIR", name_ref: "air", description: "b2c.IDS_AIR_DESCR", tooltip: null, imageClassFromFrontEnd: "rem-3-375 ic-air", checked: false },
      { ID: 3, name:"b2c.IDS_INTERNATIONAL", name_ref: "international", description: "b2c.IDS_INTERNATIONAL_DESCR", tooltip: null, imageClassFromFrontEnd: "rem-3-375 ic-international", checked: false },
    ];
    return defaultShapes;
  }

  getDefaultTimes(){
    let defaultTime: DataEntry[] = [
      { ID:1, name:"b2c.IDS_2MONTHS", description: "", imageClassFromFrontEnd: "rem-3-375 ic-tempo-2", tooltip: "", checked: false},
      { ID:2, name:"b2c.IDS_4MONTHS", description: "", imageClassFromFrontEnd: "rem-3-375 ic-tempo-4", tooltip: "", checked: false},
      { ID:3, name:"b2c.IDS_6MONTHS", description: "", imageClassFromFrontEnd: "rem-3-375 ic-tempo-6", tooltip: "", checked: false},
      { ID:4, name:"b2c.IDS_MOREMONTHS", description: "", imageClassFromFrontEnd: "rem-3-375 ic-tempo-6", tooltip: "", checked: false}
    ]
    return defaultTime;
  }

  getDefaultInternalUnit(){
    let internalUnitList : any[] = [
        { ID: 1, name:"IDS_344682_B2C", description: "IDS_344682_DESCR_B2C", image: "../../assets/img/internal-units/344682.png", tooltip: "b2c.IDS_IU_100_POPUP_FIRST_DESC", tooltip2: "b2c.IDS_IU_100_POPUP_SECOND_DESC",tooltip3: "b2c.IDS_IU_100_POPUP_THIRD_DESC", videoUrl: "./../assets/video/344682.mp4", brand:"BTI", code: "344682", price: 0,mnemonic:1, quantity:0, itemID:0, systemID:10},
        //{ ID: 2, name:"IDS_344642_B2C", description: "", image: "../../assets/img/internal-units/344642.png", tooltip: "", videoUrl: "./../assets/video/344642.mp4", checked: false, code: "344642", price: 0 },
        { ID: 3, name:"IDS_344842_B2C", description: "IDS_344842_DESCR_B2C", image: "../../assets/img/internal-units/344842.png", tooltip: "b2c.IDS_IU_300EOS_POPUP_FIRST_DESC", tooltip2: "b2c.IDS_IU_100_POPUP_SECOND_DESC",tooltip3: "b2c.IDS_IU_100_POPUP_THIRD_DESC", videoUrl: "./../assets/video/344842.mp4", brand:"BTI", code: "344842", price: 0 ,mnemonic:1, quantity:0, itemID:0, systemID:10}
      ];
    this.updatePriceRRAndItemID(internalUnitList);
    return internalUnitList;
  }

  getDefaultSmartCameraAddon(){
    let smartCameraAddonList: any[] = [
      { ID: 1, name:"NOC-S-PRO", description: "b2c.IDS_NOC-S-PRO_DESCR", image: "../../assets/img/smart-camera/NOC-S-PRO.png", tooltip: "", lateralPanelTitle: "b2c.IDS_NOC-S-PRO_LATERAL-PANEL_TITLE", lateralPanelDescription: "b2c.IDS_NOC-S-PRO_LATERAL-PANEL_DESCR", lateralPanelImage: "../../assets/img/smart-camera/NOC-S-PRO-lateral-panel.png", videoUrl: "", value: 0, brand:"NTM", code: "NOC-S-PRO", price: 0, quantity: 0, mnemonic:2, itemID:0, systemID:4},
      { ID: 2, name:"NSC-PRO", description: "b2c.IDS_NSC-PRO_DESCR", image: "../../assets/img/smart-camera/NSC-PRO.png", tooltip: "", lateralPanelTitle: "b2c.IDS_NSC-PRO_LATERAL-PANEL_TITLE", lateralPanelDescription: "b2c.IDS_NSC-PRO_LATERAL-PANEL_DESCR", lateralPanelImage: "../../assets/img/smart-camera/NSC-PRO-lateral-panel.png", videoUrl: "", value: 0, brand:"NTM", code: "NSC-PRO", price: 0, quantity: 0, mnemonic:2, itemID:0, systemID:4},
      { ID: 3, name:"DTG-PRO", description: "b2c.IDS_DTG-PRO_DESCR", image: "../../assets/img/smart-camera/DTG-PRO.png", tooltip: "", lateralPanelTitle: "b2c.IDS_DTG-PRO_LATERAL-PANEL_TITLE", lateralPanelDescription: "b2c.IDS_DTG-PRO_LATERAL-PANEL_DESCR", lateralPanelImage: "../../assets/img/smart-camera/DTG-PRO-lateral-panel.png", videoUrl: "", value: 0, brand:"NTM", code: "DTG-PRO", price: 0, quantity: 0, mnemonic:2, itemID:0, systemID:4}
  ];
    this.updatePriceRRAndItemID(smartCameraAddonList);
    return smartCameraAddonList;
  }

  getDefaultSmartThermoAddon(){
    let smartThermoAddonList: any[] = [
      { ID: 1, name:"NAV-PRO", description: "b2c.IDS_NAV-PRO_DESCR", image: "../../assets/img/smart-thermo/NVP-PRO.png", tooltip: "", lateralPanelTitle: "b2c.IDS_NAV-PRO_LATERAL-PANEL_TITLE", lateralPanelDescription: "b2c.IDS_NAV-PRO_LATERAL-PANEL_DESCR",lateralPanelImage:"../../assets/img/smart-thermo/NAV-PRO-lateral-panel.png", videoUrl: "", brand:"NTM", code: "NAV-PRO", price: 0, quantity: 0, mnemonic:2, itemID:0, systemID:5}
      //link video precedente (non esiste) -> ./../assets/video/noc-s-pro.mp4
    ];
    this.updatePriceRRAndItemID(smartThermoAddonList);
    return smartThermoAddonList;
  }

  setLocalization(obj: {}) {
    this.localization = obj;
  }

  getLocalization() {
    return this.localization;
  }

  setPossibleFinishings(arr: any){
    this.Finishings = arr;
  }

  getPossibleFinishings(){
    return this.Finishings;
  }

  getUUID(){
    return this.UUID;
  }

  setUUID(value: string){
    this.UUID = value;
  }

  setFinishing(obj: DataEntry) {
    this.finishing = obj;
    this.FinishingID = this.finishing["ID"];
    this.cs.setLabelEvent("IDS_FINISHING_LABEL_TECHNOLOGY_".concat(this.getTechnologyID().toString()));
    this.cs.setEventAction("IDS_FINISHING"+this.FinishingID,true);
  }

  setInternalUnit(obj: any){
    this.internalUnit = obj;
    //this.cs.setEventAction(this.internalUnit.name,true);
    var stringIu="";
    for (let iu of this.internalUnit) {
      stringIu+=this.als.getTranslation(iu.Name)+"-"+iu.Quantity+" ";
    }
    this.cs.setEventAction(stringIu,false);
  }

  getInternalUnit(){
    return this.internalUnit;
  }

  setSmartThermo(obj: any){
    this.smartThermo = obj;
    //this.cs.setEventAction(this.smartThermo.name,true);
    var stringSt="";
    for (let st of this.smartThermo) {
      stringSt+=st.Name+"-"+st.Quantity+" ";
    }
    this.cs.setEventAction(stringSt,false);
  }

  getSmartThermo(){
    return this.smartThermo;
  }

  setSmartThermoAddon(obj: any){
    this.smartThermoAddon = obj;
    //this.cs.setEventAction(this.smartThermoAddon.name,true);
    var stringSta="";
    for (let sta of this.smartThermoAddon) {
      stringSta+=sta.Name+"-"+sta.Quantity+" ";
    }
    this.cs.setEventAction(stringSta,false);
  }

  getSmartThermoAddon(){
    return this.smartThermoAddon;
  }

  setSmartCamera(obj: any){
    this.smartCamera = obj;
    //this.cs.setEventAction(this.smartCamera.name,true);
    var stringSc="";
    for (let sc of this.smartCamera) {
      stringSc+=sc.Name+"-"+sc.Quantity+" ";
    }
    this.cs.setEventAction(stringSc,false);
  }

  getSmartCamera(){
    return this.smartCamera;
  }

  setSmartCameraAddon(obj: any){
    this.smartCameraAddon = obj;
    //this.cs.setEventAction(this.smartCameraAddon.name,true);
    var stringSca="";
    for (let sca of this.smartCameraAddon) {
      stringSca+=sca.Name+"-"+sca.Quantity+" ";
    }
    this.cs.setEventAction(stringSca,false);
  }

  getSmartCameraAddon(){
    return this.smartCameraAddon;
  }

  clearShapeAndSwitch(){
    this.shape = {};
    this.selectedSwitch = {};
  }


  setShape(obj: DataEntry) {
    this.shape = obj;
  }

  setDigitalCommands(value: boolean) {
    this.digitalCommands = value;
  }


  setTime(obj: DataEntry) {
    this.time = obj;
    this.cs.setEventAction(this.time.name,true);
  }

  getTime(): DataEntry {
    return this.time;
  }

  setPackagesType(value: number) {
    this.packagesType = value;
  }

  getLocalizationID() {
    return this.localization ? this.localization["ID"] : false;
  }

  getLanguages() {
    return this.localization["Language"];
  }

  getDefaultLanguage() {
    return this.localization["Language"][0];
  }

  getPricelistID() {
    return this.localization["PricelistInfo"]["ID"];
  }

  setTechnologies(arr: []) {
    this.technologies = arr;
  }

  getTechnologies() {
    return this.technologies;
  }

  getTechnologyID() {
    return this.TechnologyID;
  }

  getTechnology() {
    if (this.technologies) {
      for (let tech of this.technologies) {
        if (tech["ID"] == this.getTechnologyID()) return tech;
      }
    } else {
      return null;
    }
  }

  setCover(data: {}) {
    this.cover = data;
  }

  setSerie(plate: {}) {
    this.selectedPlate = plate
    this.serieID = plate["ID"];
    var finishingID = this.getFinishingID();
    if(this.getSwitchID()){
      let switchString = "IDS_SWITCH_".concat(this.getSwitchID());
      if(finishingID==4 || finishingID==7)
        switchString=switchString.concat("_NOW");
      let plateName    = plate["Color"]
      this.cs.setEventAction(plateName.concat(this.als.getTranslation(switchString).toString()));
    }
  }
  setSerieByID(ID: number)
  {
      if (this.finishing)
      {
        let chosenFinishing = this.cachedCoverConfiguratorData[this.finishing.name_ref];
        if (chosenFinishing)
        {
          let chosenPlate = chosenFinishing.plates.find(s => s.ID === ID);
          if (chosenPlate)
          {
            this.setSerie(chosenPlate);
          }
        }
      }
  }

  getPlate(){
    return this.selectedPlate;
  }

  getSerieID() {
    return this.selectedPlate ? this.selectedPlate["ID"] : 0;
  }

  getCatalogueURL() {
    return this.localization["UrlECatalogue"];
  }

  getGTMAccount() {
    return this.localization["GoogleTagManager"];
  }


  setWhatToDo(value: DataEntry) {
    this.whatToDo = value;
    this.clearHavingBTicino();
    this.clearSystem();
    this.cs.setEventAction(this.whatToDo.name,true);
  }

  whatToDoIsUpdateImplant(){
    return this.whatToDo ? (this.whatToDo["ID"] == 3) : false;
  }

  setHavingBTicino(value: DataEntry) {
    this.havingBTicino = value;

    if(value["ID"] == 3){
      this.finishing = value;
      this.FinishingID = value["ID"];

      /* select default shape */
      let plates     = undefined;
      let switches   = undefined;
      let cachedData = this.getCachedCoverConfiguratorData()

      let activeData = cachedData[value["name_ref"]];

      if (activeData) {
        let plates = activeData.plates.filter(p => {
          return p.Default;
        });
        this.setShape({
          ID: 1,
          name:"b2c.IDS_SQUARE",
          name_ref: "square",
          description: "b2c.IDS_SQUARE_DESCR",
          tooltip: "b2c.IDS_SQUARE_TT",
          image: "../../assets/img/btns/shape-square.png",
          checked: true,
          lateralPanelId: 'livinglight-shapes-lateral'
        });

        this.selectedPlate = plates[0]
        this.serieID = plates[0]["ID"];
        this.selectedSwitch = activeData.switches[0];
        this.switchID = this.selectedSwitch["id"];
      }

    }
    this.cs.setEventAction(this.havingBTicino.name,true);
  }

  clearHavingBTicino(){
    this.havingBTicino = undefined;
    this.selectedPlate = undefined;
    this.serieID = 0;
    this.selectedSwitch = undefined;
    this.switchID = 1;
  }

  getHavingBTicino(): DataEntry {
    return this.havingBTicino;
  }

  getBoolHavingBTicino(): boolean {
    return this.havingBTicino && this.havingBTicino.ID > -1;
  }

  setHousingTypes(data: any[]) {
    this.housingTypes = data;
  }

  getNumberOfRooms(roomID: number) {
    let nrOfRooms = 0;
    for (let room of this.cachedRooms) {
      if (room["SubRooms"][0]["ID"] == roomID) {
        nrOfRooms = room["SubRooms"][0]["Quantity"];
      }
    }
    return nrOfRooms;
  }

  getHousingType(standard: boolean) {
    for (let housingType of this.housingTypes) {
      if (housingType.ID == this.gethousingTypeID()) {
        if (!standard) {
          let customHousingType = housingType;
          customHousingType["RoomTypes"] = this.getSelectedSubRooms();
          return customHousingType;
        } else {
          return housingType;
        }
      }
    }
  }

  gethousingTypeID() {
    return this.HousingTypeID;
  }

  setHousingTypeID() {
    // custom rules
    this.HousingTypeID = 5;

    let kitchenetteNr = this.getNumberOfRooms(14);
    let kitchenNr = this.getNumberOfRooms(15);
    let entranceNr = this.getNumberOfRooms(13);
    let livingRoomNr = this.getNumberOfRooms(9);
    let bedRoomNr = this.getNumberOfRooms(2);
    let bathRoomNr = this.getNumberOfRooms(17);

    if (
      livingRoomNr >= 2 &&
      bedRoomNr >= 3 &&
      bathRoomNr >= 2 &&
      entranceNr >= 3
    ) {
      this.HousingTypeID = 1; // villa
    } else if (
      livingRoomNr >= 1 &&
      bedRoomNr >= 3 &&
      bathRoomNr >= 2 &&
      entranceNr >= 3
    ) {
      this.HousingTypeID = 8; // attico
    } else if (livingRoomNr == 1 && bedRoomNr == 3 && bathRoomNr <= 2) {
      this.HousingTypeID = 3; // quadrilocale
    } else if (livingRoomNr == 1 && bedRoomNr == 2) {
      this.HousingTypeID = 4; // trilocale
    } else if (livingRoomNr == 1 && bedRoomNr == 1) {
      this.HousingTypeID = 5; // bilocale
    }
  }

  forceTechnologyID(value: number) {
    this.TechnologyID = value;
  }

  setTechnologyID() {
    this.TechnologyID = 2;
    for (let sys of this.systems) {
      if (this.homeAutomationSystems.includes(sys["Code"])) {
        this.TechnologyID = 3;
      }
    }

    // this.cs.setLabelEvent("IDS_FINISHING_LABEL_TECHNOLOGY_".concat(this.TechnologyID.toString()));
  }

  setTotalPoints(data: {}) {
    /* set default light types */
    if (data && data["byRooms"]) {
      for (var room in data["byRooms"]) {
        if (data["byRooms"].hasOwnProperty(room)) {
          let lightPointsRoomProperty = data["byRooms"][room]["LightPoints"];
          for (var i: number = 0; i < lightPointsRoomProperty.length; i++) {
            lightPointsRoomProperty[0][
              "PointType"
            ] = this.getDefaultLightPointType(
              lightPointsRoomProperty[0]["ComandiLuceSelected"],
              data["info"]["LightPointType"]
            );
          }
        }
      }
    }

    this.totalPoints = data;
  }

  getTotalPoints() {
    return this.totalPoints;
  }

  getAddons() {
    let listAddons=[];
    if(this.internalUnit){
    this.internalUnit.forEach(s => {

        let addon: addonItem = {
          itemID: s.itemID,
          quantity:s.quantity,
          code:s.code,
          systemID:s.systemID,
          mnemonic:s.mnemonic};
        listAddons.push(addon);

    });
  }
    if (this.smartCamera){
      this.smartCamera.forEach(s => {

          let addon: addonItem = {
            itemID: s.itemID,
            quantity:s.quantity,
            code:s.code,
            systemID:s.systemID,
            mnemonic:s.mnemonic};
          listAddons.push(addon);

      });
    }
    if (this.smartCameraAddon){
      this.smartCameraAddon.forEach(s => {

          let addon: addonItem = {
            itemID: s.itemID,
            quantity:s.quantity,
            code:s.code,
            systemID:s.systemID,
            mnemonic:s.mnemonic};
          listAddons.push(addon);
      });
    }
    if (this.smartThermo){
      this.smartThermo.forEach(s => {

          let addon: addonItem = {
            itemID: s.itemID,
            quantity:s.quantity,
            code:s.code,
            systemID:s.systemID,
            mnemonic:s.mnemonic};
          listAddons.push(addon);

      });
    }
    if (this.smartThermoAddon){
    this.smartThermoAddon.forEach(s => {
                let addon: addonItem = {
            itemID: s.itemID,
            quantity:s.quantity,
            code:s.code,
            systemID:s.systemID,
            mnemonic:s.mnemonic};
          listAddons.push(addon);

      });
    }
    return listAddons;
  }
  getDefaultLightPointType(nComandi: number, lightPointTypes: any[]) {
    var techID = this.getTechnologyID();

    let lightTypes = lightPointTypes.filter(function(point) {
      return (
        point["TechnologyID"].indexOf(techID) !== -1 &&
        point["MinLightCommand"] <= nComandi &&
        point["MaxLightCommand"] >= nComandi
      );
    });

    return lightTypes && lightTypes.length > 0 ? lightTypes[0] : undefined;
  }

  getBlankPlateBoxEvaluation(quotation: {}) {
    var that = this;

    quotation["isModifiedForReport"] = true;

    if (!quotation["BoxEvaluation"]) quotation["BlankPlateEvaluation"] = false;

    var covSystems = this.getSystems().filter(sys => sys["Code"] == "COV");

    if (covSystems.length > 0) {
      var covSystem = covSystems[0];
      var covItems = this.getPackageItems().filter(
        item => item["SystemID"] == covSystem.ID
      );
      let roomsData = [];

      covItems.forEach(function(item) {
        if (["Box", "BlankPlate"].indexOf(item.Type) !== -1) {
          var idxItem = that.getPackageItems().indexOf(item);
          if (item.RoomID != 0 && item.RoomIterator >= 0) {
            roomsData.push({ ID: item.RoomID, Iterator: item.RoomIterator });
          }
          if (idxItem !== -1) {
            that.getPackageItems().splice(idxItem, 1);
          }
        }
      });
    }
  }

  setCachedSystems(data: any[]) {
    data.forEach(s => {
      if (s.Code) {
        s.tooltip = "b2c.IDS_" + s.Code + "_TIP";
      }
    });
    this.cachedSystems = data;
  }

  getCachedSystems() {
    return this.cachedSystems;
  }

  setSystems(data: any[]) {
    this.systems = data;
  }

  getSystems(hide: boolean = false) {
    /* hide -> hide default systems */
    let result = [];

    if (hide){
      result = this.systems.filter(sys => sys["Code"] !== 'COV' && sys["Code"] !== "FTT" && sys["Code"] !== "QDC" && sys["Code"] !== "QDP"  && sys["Code"] !== "SER" );
    }
    else {
      result = this.systems;
    }
    return result;
  }

  clearSystem(){
    this.systems = undefined;
  }

  getSystemByCode(code: string) {
    return this.getSystems().filter(sys => sys["Code"] === code);
  }

  getSelectedPlugs() {
    return JSON.stringify(this.totalPoints) !== '{}'
      ? this.totalPoints["sumPoints"]["plugNumber"]
      : [];
  }

  updateSystemsSelected(data: any) {
    if (data.ID) {
      if (!this.systems) this.systems = [];
      let systemIdx = this.systems.findIndex(s => s.ID === data.ID);
      if (systemIdx === -1 && data.checked) {
        this.systems.push(data);
      } else if (systemIdx !== -1 && !data.checked) {
        this.systems.splice(systemIdx, 1);
      }
      var sysArray=[];
      var i=0;
      for (let sys of this.systems) {
        if(sys.ID!=16){
          sysArray[i]=this.als.getTranslation(sys.Description+'_B2C');
          i++;
        }
      }
      this.cs.setEventAction(sysArray,false);
    }
  }

  // getRooms() {
  //   return this.rooms;
  // }

  // setRooms(data: any[]) {
  //   this.rooms = data;
  //   var stringRoom="";
  //   for (let room of this.rooms) {
  //       stringRoom+=this.als.getTranslation(room.RoomGroupName)+"-"+room.SubRooms[0].Quantity+" ";
  //   }
  //   this.cs.setEventAction(stringRoom,false);
  // }

  setCachedRooms(data: any[]) {
    data.forEach(r => {
      if (r.SubRooms.length > 0) {
        //if ([8, 14, 15].indexOf(r.SubRooms[0].ID) !== -1) {
          r.tooltip = r.RoomGroupName + "_TIP";
        //}
      }
    });
    this.cachedRooms = data;
    this.setAnalitycsEvent();
  }

  getCachedRooms() {
    this.setAnalitycsEvent();
    return this.cachedRooms;
  }

  protected setAnalitycsEvent(){
    if(!(this.cachedRooms == undefined || this.cachedRooms.length == 0)){
      var stringRoom="";
      for (let room of this.cachedRooms) {
          stringRoom+=this.als.getTranslation(room.RoomGroupName)+"-"+room.SubRooms[0].Quantity+" ";
      }
      this.cs.setEventAction(stringRoom,false);
    }
  }
  getSelectedSubRooms() {
    let arr = [];
    for (let room of this.cachedRooms) {
      if (room["SubRooms"] && room["SubRooms"][0]["Quantity"] > 0) {
        arr.push(room["SubRooms"][0]);
      }
    }
    return arr;
  }

  getSelectedRooms() {
    let arr = [];
    for (let room of this.cachedRooms) {
      if (room["SubRooms"] && room["SubRooms"][0]["Quantity"] > 0) {
        arr.push(room);
      }
    }
    return arr;
  }

  getWhatToDo(): DataEntry {
    return this.whatToDo;
  }

  getFinishing(): DataEntry {
    return this.finishing;
  }

  getFinishingID(): number {
    return this.FinishingID;
  }

  getShape(): DataEntry {
    return this.shape;
  }

  getShapeID(): number {
    return this.shape != null ? this.shape.ID : null;
  }

  setSwitch(s: {}) {
    this.selectedSwitch = s;
    this.switchID = this.selectedSwitch["id"];
    var finishingID=this.getFinishingID();
    if(this.switchID){
      var switchString="IDS_SWITCH_".concat(this.switchID.toString());
      if(finishingID==4 || finishingID==7)
        switchString=switchString.concat("_NOW");
      this.cs.setEventAction(this.getPlate().Color.concat(this.als.getTranslation(switchString).toString()));
    }
  }
  setSwitchByID(ID: number){
    ID = Number(ID);
    if (this.finishing)
    {
      let chosenFinishing = this.cachedCoverConfiguratorData[this.finishing.name_ref];
      if (chosenFinishing)
      {
        let chosenSwitch = chosenFinishing.switches.find(s => s.id === ID);
        if (chosenSwitch)
        {
          this.setSwitch(chosenSwitch);
        }
      }
    }
  }

  getSwitch(){
    return this.selectedSwitch;
  }

  getSwitchID() {
    return this.selectedSwitch ? this.selectedSwitch["id"] : 0;
  }

  getDigitalCommands() {
    return this.digitalCommands;
  }

  getHomeAutomationSystems() {
    return this.homeAutomationSystems;
  }

  setB2CParams(name: string, value: string) {
    this[name] = value;
  }

  setPackageItems(data: any[]) {
    this.packageItems = data;
    this.setTotalAmount();
  }

  setTotalAmount(){
    //$min = (floor(($price-($price*10/100))/10))*10;
    //$max = (ceil(($price+($price*10/100))/10))*10;
    var price = this.getTotal() ;
    if (price)
    {
      var total=price["Specification"]['RRTotal'];
      this.totalAmount={ rangeMin : (Math.floor((total-(total*5/100))/10))*10 , rangeMax : (Math.ceil((total+(total*5/100))/10))*10 , amount : total}
    }
    else
    {
      this.totalAmount={ rangeMin : 0 , rangeMax : 0, amount : 0}
    }
  }
  getRangeMin(){
    if (this.totalAmount)
      return this.totalAmount.rangeMin;
    else
      return 0
  }
  getRangeMax(){
    if (this.totalAmount)
      return this.totalAmount.rangeMax;
    else
      return 0
  }
  getTotalAmount(){
    if (this.totalAmount)
      return this.totalAmount.amount;
    else
      return 0
  }

  getPackageItems() {
    if (this.getBoolHavingBTicino()){
      //this.removeUnconnectedItems();
    }
    return this.packageItems;
  }

  getSystemItems(systemID: number) {
    return this.packageItems.filter(item => item["SystemID"] === systemID);
  }

  getSystemTotals(systemID: number) {
    let totals = {};

    if (this.packageItems.length > 0) {
      if (systemID>=0)
      {
        totals["TotalRR"] = this.packageItems
          .filter(item => item["SystemID"] === systemID)
          .map(item => +item["PriceRR"])
          .reduce((sum, current) => sum + current);
      }
      else{
        totals["TotalRR"] = 0;
      }
    } else {
      totals["TotalRR"] = 0;
    }

    totals["SpecialTotal"] = 0;
    totals["NetTotal"] = 0;
    totals["CurrentConsumptionPlus"] = 0;
    totals["CurrentConsumptionMinus"] = 0;
    totals["CurrentConsumptionRapport"] = 0;
    totals["DINOccupationPlus"] = 0;
    totals["DINOccupationMinus"] = 0;
    totals["DINOccupationRapport"] = 0;

    return totals;
  }

  getCustomSystem() {
    let arr = [];
    let cSys = {};

    cSys["State"] = "selected";
    cSys["Items"] = this.getSystemItems(-1);
    cSys["EditedTitle"] = "Articoli condivisi";
    cSys["ID"] = -1;
    cSys["isTempID"] = true;
    cSys["isMandatory"] = true;
    cSys["SortOrder"] = 17; //tmp
    cSys["Custom"] = 1;
    cSys["Total"] = this.getSystemTotals(-1);

    arr.push(cSys);
    return arr;
  }

  getRoomsItems(roomID: number) {
    return this.packageItems.filter(item => item["RoomID"] === roomID);
  }

  getRoomTotals(roomID: number) {
    let totals = {};

    if (this.packageItems.length > 0) {
      if (roomID>=0)
      {
        totals["TotalRR"] = this.packageItems
        .filter(item => item["RoomID"] === roomID)
        .map(item => +item["PriceRR"])
        .reduce((sum, current) => sum + current);
      }
      else{
        totals["TotalRR"] = 0;
      }

    } else {
      totals["TotalRR"] = 0;
    }

    totals["SpecialTotal"] = 0;
    totals["NetTotal"] = 0;
    totals["CurrentConsumptionPlus"] = 0;
    totals["CurrentConsumptionMinus"] = 0;
    totals["CurrentConsumptionRapport"] = 0;
    totals["DINOccupationPlus"] = 0;
    totals["DINOccupationMinus"] = 0;
    totals["DINOccupationRapport"] = 0;

    return totals;
  }

  removeUnconnectedItems(){
    for (let i = 0; i < this.packageItems.length; i++) {
      if (!this.packageItems[i]["Connected"]){
        this.packageItems[i]["Quantity"] = 0;
      }
    }
  }

  getTotal(){
    let items = this.getPackageItems();

    let totals = {};
    totals["Specification"] = {};
    totals["Specification"]['RRTotal']       = 0;
    totals["Specification"]['SpecialTotal']  = 0;
    totals["Specification"]['NetTotal']      = 0;
    totals["Variants"] = {};
    totals["Variants"]['RRTotal']       = 0;
    totals["Variants"]['SpecialTotal']  = 0;
    totals["Variants"]['NetTotal']      = 0;

    for (let i = 0; i < items.length; i++) {
      totals["Specification"]['RRTotal']      = totals["Specification"]['RRTotal'] + items[i]["Quantity"] * items[i]["PriceRR"];
      totals["Specification"]['SpecialTotal'] = totals["Specification"]['SpecialTotal'] + items[i]["Quantity"] * items[i]["SpecialPrice"];
      totals["Specification"]['NetTotal']     = totals["Specification"]['NetTotal'] + items[i]["Quantity"] * items[i]["DefaultNetPrice"];
    }

    return totals;
  }

  getCustomRooms() {
    let arr = [];
    let cRoom = {};

    cRoom["Items"] = this.getRoomsItems(-1);
    cRoom["EditedTitle"] = "Articoli senza locale";
    cRoom["ID"] = -1;
    cRoom["isTempID"] = true;
    cRoom["isMandatory"] = true;
    cRoom["Priority"] = 2;
    cRoom["Iterator"] = 0;
    cRoom["Custom"] = 1;
    cRoom["Total"] = this.getRoomTotals(-1);

    arr.push(cRoom);

    return arr;
  }

  getQuotationData() {
    let q = {};

    q["Pricelist"] = this.localization["PricelistInfo"];
    q["SummaryItemEdited"] = [];
    q["isModified"] = false;
    q["isModifiedForReport"] = true;
    q["isModifiedForServicesQuestion"] = true;
    q["CanGenerateRoomReport"] = true;
    q["CanGenerateSystemReport"] = true;
    q["ExceedNrDevicesLimit"] = false;
    q["HousingType"] = this.getHousingType(false);
    q["HousingTypeCustomise"] = this.housingTypeCustomise;
    q["Packages"] = [];
    q["Backup"] = {};
    q["Backup"]["HousingType"] = this.getHousingType(false);
    q["Systems"] = this.getSystems();
    q["Technology"] = this.getTechnology();
    q["Rooms"] = this.getSelectedSubRooms();
    q["Finishing"] = this.getFinishing();
    q["SeriesID"] = this.getSerieID();
    q["SwitchID"] = this.getSwitchID();
    q["ProjectTitleInReport"] = false;
    q["WorkcardInReport"] = false;
    q["CustomerInReport"] = true;
    q["EmailInReport"] = true;
    q["PhoneNumberInReport"] = false;
    q["IDWorkInReport"] = false;
    q["NoteInReport"] = true;
    q["ViewTypeSummary"] = "system";
    q["ToggableViewType"] = true;
    q["CustomSystems"] = this.getCustomSystem();
    q["CustomRooms"] = this.getCustomRooms();
    q["BoxEvaluation"] = true;
    q["BlankPlateEvaluation"] = true;
    q["DiscountsByStatisticalFamily"] = [];
    q["Items"] = this.getPackageItems();
    q["Total"] = this.getTotal();
    q["SystemsRecalculation"] = this.getSystems();
    q["ProjectTitle"] = "";
    q["Workcard"] = "";
    q["Customer"] = this.summaryFormData ? (this.summaryFormData.name + " " + this.summaryFormData.surname) : "";
    q["Email"] = this.summaryFormData ? this.summaryFormData.email : "";
    q["Note"] = ""; // "B2C";
    q["LocalizationID"] = this.getLocalizationID();
    q["QuotationReason"] = this.getWhatToDo()["name"];
    if (this.getTime() != undefined) { q["ForecastTime"] = this.getTime()["name"];} else {q["ForecastTime"] = "Error read time"; }
    q["OldFinishing"] = this.getHavingBTicino() ? this.getHavingBTicino()["name"] : "b2c.IDS_DONTKNOW";
    //q["InternalUnitCode"] = "";this.internalUnit;//?.code;
    // q["AddonInternalUnit"] = this.internalUnit;
    // q["AddonSoftSecurity"] = this.smartCameraAddon;
    // q["AddonThermo"] = this.smartThermoAddon;


    if (this.systems.filter(s => s.ID == 5).length > 0 && this.TechnologyID == 2) {
      q["TermoSystemZona"] = this.termoSystemZona;
      q["TermoSystemType"] = this.termoSystemType;
      q["TermoHeatingSystem"] = this.termoHeatingSystem;
    }

    let host = window.location.hostname != "localhost" ? window.location.hostname : "http://casab2c.demorooms.com";
    q["LocalizationHost"] = host;

    return q;
  }

  reloadQuotationParams(qData: any){
    var that = this;

    this.HousingTypeID = qData['HousingType'].ID;
    this.TechnologyID = qData['Technology'].ID;

    /* set whattodo */
    //qData["QuotationReason"] this.getWhatToDo()["name"];
    if (qData["QuotationReason"]){
      let qre = this.getDefaultWhatToDo().filter(wtd => {
        return wtd["name"] == qData["QuotationReason"];
      });
      this.setWhatToDo(qre[0]);
    }

    /* set Rooms */
    try
    {
      let cr = this.getCachedRooms();
      for (let room of qData['Rooms']) {
        for(let roomToUpd of cr){
          if (roomToUpd.SubRooms[0].ID == room.ID){
            if (!roomToUpd.SubRooms[0].Quantity){
              roomToUpd.SubRooms[0].Quantity = 1;
            } else {
              roomToUpd.SubRooms[0].Quantity++;
            }
            break;
          }
        }
      }
      this.setCachedRooms(cr);
    }
    catch{
      console.log("Problem in loading CachedRooms")
    }


    /* set Systems */
    let cs = this.getCachedSystems();
    //Prima di tutto compilo il campo selected per tutti i system ricevuti
    for(let sysToUpd of cs){
      sysToUpd.State = "selected";
    }

    for (let sys of qData['Systems']){
      for(let sysToUpd of cs){
        if (sysToUpd.ID == sys.ID){
          sysToUpd.checked = true;
          //sysToUpd.State = "selected";
          break;
        }
      }
    }
    this.setSystems(cs);

    /* Set Addons */
    if (qData['Addons'])
    {
      let addons = qData['Addons'];
      /* Set Internal Unit */
      if ((this.getInternalUnit() == undefined) || (this.getInternalUnit().length == 0)){
        this.internalUnit = this.getDefaultInternalUnit();
      }
      for (let iu of this.internalUnit)
      {
          iu.quantity = this.getItemsNumberByCode(addons,iu.code);
      }

      /* Set Smart Camera -> non lo faccio perchè al momento è gestito in automatico in base a quale system è scelto */

      /* Set Smart Camera Addon */
      if ((this.getSmartCameraAddon() == undefined) || (this.getSmartCameraAddon().length == 0)){
        this.smartCameraAddon = this.getDefaultSmartCameraAddon();
      }
      for (let sca of this.smartCameraAddon)
      {
          sca.quantity = this.getItemsNumberByCode(addons,sca.code);
      }

      /* Set Smart Thermo Addon */
      if ((this.getSmartThermoAddon() == undefined) || (this.getSmartThermoAddon().length == 0)){
        this.smartThermoAddon = this.getDefaultSmartThermoAddon();
      }
      for (let sta of this.smartThermoAddon)
      {
          sta.quantity = this.getItemsNumberByCode(addons,sta.code);
      }

    }


    /* set Finishing */
    //Finishing
    if (qData['Finishing']){
      let dataEntryFin = {
        ID: qData['Finishing'].ID,
        name: qData['Finishing'].Nome,
        name_ref: qData['Finishing'].Nome_ref,
        description: qData['Finishing'].Description,
        image: "../../assets/img/btns/finishing-" + qData['Finishing'].Nome_ref + ".png",
        tooltip: qData['Finishing'].ReportDescription,
        checked: false,
        lateralPanelId: qData['Finishing'].Nome_ref.replace(/\s/g, '-').toLowerCase() + "-lateral"
      }
      this.setFinishing(dataEntryFin);

      //SeriesID
      this.setSerieByID(qData['SeriesID']);

      if (qData['SeriesID']){
        if (qData['Finishing'].Nome_ref.replace(/\s/g, '-').toLowerCase() == 'livinglight'){
          this.ws.getSerieByID(qData['SeriesID']).subscribe(data => {
            for (let shape of that.dataEntryShapes){
              if (shape.name_ref == data['Shape'].toLowerCase()){
                shape.checked = true;
                that.setShape(shape);
              }
            }
          });
        }
        for (let plate of that.cachedCoverConfiguratorData[qData['Finishing'].Nome_ref].plates){
          plate.Default = plate.ID == qData['SeriesID']
        }

        for (let swi of that.cachedCoverConfiguratorData[qData['Finishing'].Nome_ref].switches){
          swi.default = swi.id == qData['SwitchID'];
        }

        if (that.dataEntrySwitch){
          for (let swi of that.dataEntrySwitch){
            swi.checked = swi.ID == qData['SwitchID'];
          }
        }
        else
        {
          console.log("ERROR -> that.dataEntrySwitch is undefined");
        }
      };

      //SwitchID
      this.setSwitchByID(qData['SwitchID']);
    }

    /* set Times */
    if (this.dataEntryTimes)
    {
      // ForecastTime
      for (let time of this.dataEntryTimes){
          if (time.name == qData['ForecastTime']){
            time.checked = true;
            that.setTime(time);
            break;
          }
      }
    }
    else
    {
      console.log("ERROR -> that.dataEntryTimes is undefined");
    }

    if (qData["Items"])
    {
      this.setPackageItems(qData["Items"]);
    }
    /* set FormParams*/
    //Email
    //Customer to split
    this.summaryFormData.name = qData['Customer'].substring(0, qData['Customer'].indexOf(' '));
    this.summaryFormData.surname = qData['Customer'].substring(qData['Customer'].indexOf(' ') + 1);
    this.summaryFormData.email = qData['Email'];
    this.summaryFormData.privacy = true;

    this.sendQuotationFormData.name = qData['Customer'].substring(0, qData['Customer'].indexOf(' '));
    this.sendQuotationFormData.surname = qData['Customer'].substring(qData['Customer'].indexOf(' ') + 1);
    this.sendQuotationFormData.email = qData['Email'];
    this.sendQuotationFormData.telephone = qData['PhoneNumber'];
    this.sendQuotationFormData.province = qData['Province'];
    this.sendQuotationFormData.city = qData['City'];
    this.sendQuotationFormData.postalcode = qData['PostalCode'];
    this.sendQuotationFormData.address = qData['Address'];
    this.sendQuotationFormData.message = qData['Note'];
    this.sendQuotationFormData.privacy = false;
    this.sendQuotationFormData.share = false;

    /* 8BC116-545E54 */
  }

  private getItemsNumberByCode(list: any[], code: string)
  {
    for (let item of list)
    {
      if (item.code == code)
      {
        return item.quantity;
      }
    }
    return 0;
  }

  setCachedCoverConfiguratorData(value: any) {
    this.cachedCoverConfiguratorData = value;
  }

  getCachedCoverConfiguratorData() {
    return this.cachedCoverConfiguratorData;
  }

  getAnagUser(){
    let user = {};
    user["Name"] = this.summaryFormData.name;
    user["Surname"] = this.summaryFormData.surname;
    user["Email"] = this.summaryFormData.email;
    user["flagAgg"] = this.summaryFormData.marketing ? this.summaryFormData.marketing : false;
    return user;
  }

  getAdditionInfoForInstaller(){
    let additionalInfo = {};
    additionalInfo["address"] = this.sendQuotationFormData.address;
    additionalInfo["province"] = this.sendQuotationFormData.province;
    additionalInfo["city"] = this.sendQuotationFormData.city;
    additionalInfo["postalcode"] = this.sendQuotationFormData.postalcode;
    additionalInfo["phonenumber"] = this.sendQuotationFormData.telephone;
    additionalInfo["message"] = this.sendQuotationFormData.message ? this.sendQuotationFormData.message : false;
    return additionalInfo;
  }

  setUserID(uID: number){
    this.userID=uID;
  }

  getUserID() {
    return this.userID ? this.userID : false;
  }



  private updatePriceRRAndItemID(list: any[]) {
    for (let sc of list) {
      this.ws.getPricelistItem(
        this.getLocalizationID(),
        sc.brand,
        sc.code).subscribe(data => {
          sc.price = data["PriceRR"];
          sc.itemID = data["ItemID"];
        });
    }
  }

  setSelectedInstaller(value: DataEntry) {
    this.selectedInstaller = value;
  }
  getSelectedInstaller(): DataEntry {
    return this.selectedInstaller;
  }
  setProvinceOfSelectedInstaller(value: string) {
    this.provinceOfSelectedInstaller = value;
  }
  getProvinceOfSelectedInstaller(): string {
    return this.provinceOfSelectedInstaller;
  }
  setSelectedInstallerFullData(value: {id: number, name: string, province: string, city: string, address: string, email: string, idsalesforce: string}) {
    this.selectedInstallerFullData = value;
  }
  getSelectedInstallerFullData(): {id: number, name: string, province: string, city: string, address: string, email: string, idsalesforce: string} {
    return this.selectedInstallerFullData;
  }
  getListOfInstaller(): any[] {
    return this.listInstallersWS;
  }
  setListOfInstaller(value: any[]) {
    this.listInstallersWS = value;
  }

  loadInstallerFromWS(): void{
    this.ws.getAllInstallers(this.getLocalizationID()).subscribe(data => {
      let listInstallers = [];
      if(data['totalSize'])
      {
        let index=1;
        data['records'].forEach(element => {
          let livSmart=0;
          if (element['Livello_SMART__c'])
            livSmart = parseInt(element['Livello_SMART__c']);
          let postalCode=0;
          if (element['BillingPostalCode'])
            postalCode = parseInt(element['BillingPostalCode']);

          listInstallers.push({
            id: index,
            name: element['Name'],
            province: element['BillingState'],
            city: element['BillingCity'],
            address: element['BillingStreet'],
            email: element['Z_Posta_Elettronica__c'],
            // website: element['Website'],
            livellosmart: livSmart,
            postalCode: postalCode,
            idsalesforce: element['Id']
          });
          index++;
        });
      }
      //test per loader
      // setTimeout(() => {
      // this.cs.changeLoaderStatus(false);
      // this.setListOfInstaller(listInstallers);
      // }, 4000);
      this.cs.changeLoaderStatus(false);
      this.setListOfInstaller(listInstallers);
      //this.exportCsv(this.listInstallers, 'installers.csv');
     ;});
   }
  //funzione di test per mandare l'elenco installatori a CREEO/Bticino
  exportCsv(data: any[], filename: string) {
    const stringBuilder = [];
    const header = [];
    header.push('idSF');
    header.push('name');
    header.push('province');
    header.push('city');
    header.push('address');
    header.push('postalCode');
    header.push('email');
    header.push('livellosmart');
    stringBuilder.push(header.join(';'));

    data.forEach(obj => {
      const row = [];
      row.push(obj['idSF']);
      row.push(obj['name']);
      row.push(obj['province']);
      row.push(obj['city']);
      row.push(obj['address']);
      row.push(obj['postalCode']);
      row.push(obj['email']);
      row.push(obj['livellosmart']);
      stringBuilder.push(row.join(';'));
    });
    let csvString =  stringBuilder.join('\n');
    const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  getFinishings(localizationID: number){
    this.ws
      .getFinishingsByLocalization(localizationID)
      .subscribe(finishingsData => {
        this.setPossibleFinishings(finishingsData);
      });
  }

  getCoverData(localizationID: number){
    this.ws
      .getCoverConfiguratorData(localizationID).subscribe(coverData => {
        this.setCachedCoverConfiguratorData(coverData);
    });
  }

  async preloadDataSkippedPage()
  {
    /* preload data next steps: Housing types */
    await this.ws.getHousingTypes().toPromise().then((data) => {
      if (Array.isArray(data)) {
        this.setHousingTypes(data);
      }
    });
    /* preload data next steps: Distinct rooms */
    await this.ws
      .getListOfDistinctRoomTypes(this.getLocalizationID())
      .toPromise().then((data) => {
        if (Array.isArray(data)) {
          this.setCachedRooms(data);
        }
    });

    await this.ws.getSystems(this.getLocalizationID()).toPromise().then((data) => {
      if (Array.isArray(data)) {
        this.setCachedSystems(data);
      }
    });
  }
}
